module.exports = __webpack_public_path__ + "static/media/temp_41.9b6a24f5.jpg";